// extracted by mini-css-extract-plugin
export default {"mainContainer":"Tool_mainContainer__M9wE6"};